import {     
    PRODUCT_LOAD,
} from '../Actions/Product.action';

const defaultState = { 
    payload: {        
        selectedVariant: {},
        stringBuilderGuid: {},
        productItem : {},
        colorText: {},
        colors : [],
        sizeText : {},
        sizes: [],
        brandPage: {},
        stockStatusJsonData : {},
        productConfiguratorPricesJsonData : {},
        productConfiguratorStockStatusJsonData : {},
        productConfiguratorJsonData : {},
        bundleProducts : [],
        featureList : [],
        bundleProductsList : {},
        accessoriesProducts: [],
        recommendedAccessories : [],
        similarProducts : [],
        mostSoldProducts : [],
        variants : [],
        informationTemplate : [],
        specificationTemplate : [],
        detailedSpecification : {},
        productTabSpecificationsIsActive : {},
        productTabProductInformationIsActive : {},
        productTabDetailedSpecification : {},
        productFieldValue : [],
        slideShowItems : [],
        comment : {},
        GTIN : {},
        packagingQuantity : {},
        productInfoMessage : {},
        stockInfoMessage : {},            
    }       
}

export const product = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {        
        case PRODUCT_LOAD:         
            return {
                ...state,
                payload: {
                    ...state.payload,
                    ...payload,
                }
            }
        default:
            return state;
    }
}